import { makeRequestAction } from './index';

export const getEmailTemplate = makeRequestAction('GET_EMAIL_TEMPLATE', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
